import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import axios from 'axios';

Vue.config.productionTip = false;

axios.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }

    return config;
  },
  err => {
    console.log('[main.js] - Error trying to set axios request interceptor');
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  function(err) {
    console.log('[main.js] - Axios response interceptor err:', err);
    if (err.response && err.response.status === 401) {
      console.log('[main.js] - err.response.status: ' + err.response.status);
      store.dispatch('auth/refreshToken');
    } else {
      console.log('[main.js] - err:', err);
    }
    return Promise.reject(err);
  }
);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
